module.exports = __webpack_public_path__ + "static/media/sidebar7.f90a35db.jpg";